import React, {PureComponent} from 'react';
import {ICustomerCardsSearchBarState, ICustomerCardType} from "../../models/customer-card";
import {SwitchButton, SwitchButtonState} from "../SwitchButton/SwitchButton";
import {Button} from "react-bootstrap";
import { AuthenticationContext } from 'services/context/authentication.context';

export function selectTheme(theme: any) {
    return ({
        ...theme,
        borderWidth: 2,
        colors: {
            ...theme.colors,
            text: '#a5d6db',
            primary25: '#a5d6db',
            primary: '#008C9A',
        },
    })
}

interface IRequestCardButtonProps {
    title: string;
    onClick: () => void;
    disabled?: boolean;
}

export function RequestCardButton({ title, onClick, disabled }: IRequestCardButtonProps) {
    return (
        <Button variant="dark" className="ml-2 ml-md-3" onClick={onClick} disabled={disabled}>
            <span className="d-none d-xl-flex text-nowrap">{title}</span>
            <span className="d-flex d-xl-none mx-1">+</span>
        </Button>
    );
}

interface ICustomerCardsSearchProps {
    customer?: any,
    paymentCardCount: number,
    discountCardCount: number,
    onTypeChange: (selectedCardType: ICustomerCardType) => void
    onSearchQueryChange: (searchQuery: string) => void
    requestButton?: React.ReactNode;
}

export class CustomerCardsSearchBar extends PureComponent<ICustomerCardsSearchProps, ICustomerCardsSearchBarState> {
    static contextType = AuthenticationContext;

    constructor(props: ICustomerCardsSearchProps) {
        super(props);
        this.state = {
            searchQuery: null,
            selectedCardType: ICustomerCardType.PAYMENT_CARD,
            showBlockedCards: false
        };
    }

    onTypeSwitchChange = (active: SwitchButtonState) => {
        this.setState({
            selectedCardType: active === SwitchButtonState.LEFT ? ICustomerCardType.PAYMENT_CARD : ICustomerCardType.DISCOUNT_CARD
        });
        this.props.onTypeChange(
            active === SwitchButtonState.LEFT ? ICustomerCardType.PAYMENT_CARD : ICustomerCardType.DISCOUNT_CARD
        );
    };

    onSearchChange = (event: any) => {
        this.setState({
            searchQuery: event.target.value
        });
        this.props.onSearchQueryChange(event.target.value);
    };

    render() {
        const typeSwitch = <SwitchButton
            onActiveChange={this.onTypeSwitchChange}
            labelLeft={"Krediitkaardid (" + this.props.paymentCardCount + ")"}
            labelRight={"Sooduskaardid (" + this.props.discountCardCount + ")"}
            active={this.state.selectedCardType === ICustomerCardType.PAYMENT_CARD ? SwitchButtonState.LEFT : SwitchButtonState.RIGHT}
        />;

        return (
            <>
                <h2>
                    Kaardid
                </h2>
                <div className="customer-cards__search-bar d-flex flex-lg-nowrap">
                    <input
                        placeholder="Otsi nime või numbri järgi"
                        className='form-control d-md-flex d-none mr-2'
                        style={{ maxWidth: '250px', minWidth: '180px' }}
                        onChange={this.onSearchChange}
                        value={this.state.searchQuery ? this.state.searchQuery : ""}
                    />
                    <div className="d-flex ml-auto">
                        {typeSwitch}
                    </div>
                    { this.props.requestButton }
                </div>
            </>
        )
    }
}